import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import API from "../api";
import "./ResultsScreen.css";
import logo from "../assets/images/logo_cyber_112.png";
import successicon from "../assets/images/successicon.png";

const ResultsScreen = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {
        module_id,
        section_id,
        screen_id,
        screenCounter,
        sectionCounter,
        recivedScore,
        numberOfTrys,
        scorePerQuestion = 0,
        moduleScore = 0
    } = location.state || {};

    const [screensNum, setScreensNum] = useState(0);
    console.log("📌 Data iz location.state:", location.state);

    useEffect(() => {
        API.get(`module/getMaxNumOfScreens/${module_id}/${section_id}`)
            .then(response => setScreensNum(response.data))
            .catch(error => console.error("❌ Greška pri dohvaćanju broja ekrana:", error));
    }, [module_id, section_id]);

    const nextLecture = async () => {
        try {
            const finalScreenResponse = await API.get(`module/getFinalScreen/${module_id}`);
            const finalScreenData = finalScreenResponse.data[0];

            const response = await API.get(`module/getModuleInfo/${module_id}`);
            const allScreens = response.data;

            const currentIndex = allScreens.findIndex(
                s => s.section_id === section_id && s.screen_id === screen_id
            );

            if (currentIndex === -1) {
                const firstScreenInSection = allScreens.find(s => s.section_id === section_id);

                if (firstScreenInSection) {
                    navigate("/email-next-screen", {
                        state: {
                            module_id,
                            section_id: firstScreenInSection.section_id,
                            screen_id: firstScreenInSection.screen_id,
                            screenCounter: 1,
                            sectionCounter,
                            numberOfTrys: 0,
                            scorePerQuestion,
                            moduleScore
                        }
                    });
                    return;
                }

                let finalRoute = "";
                switch (finalScreenData?.final_screen) {
                    case "EmailFinals":
                        finalRoute = "/email-final";
                        break;
                    case "PasswordSecurityFinal":
                        finalRoute = "/password-security-final-screen";
                        break;
                    case "MalwareFinal":
                        finalRoute = "/malware-final-screen";
                        break;
                    case "SocialNetworkFinal":
                        finalRoute = "/social-network-final-screen";
                        break;
                    default:
                        finalRoute = "/dash";
                }

                navigate(finalRoute, {
                    state: {
                        module_id,
                        moduleScore
                    }
                });
                return;
            }

            const isLastScreen = currentIndex === allScreens.length - 1;
            const hasMoreQuestions = parseInt(finalScreenData?.count) > 0;

            if (isLastScreen && !hasMoreQuestions) {
                let finalRoute = "";
                switch (finalScreenData.final_screen) {
                    case "EmailFinals":
                        finalRoute = "/email-final-screen";
                        break;
                    case "PasswordSecurityFinal":
                        finalRoute = "/password-security-final-screen";
                        break;
                    case "MalwareFinal":
                        finalRoute = "/malware-final-screen";
                        break;
                    case "SocialNetworkFinal":
                        finalRoute = "/social-network-final-screen";
                        break;
                    default:
                        finalRoute = "/dashboard";
                }

                navigate(finalRoute, {
                    state: {
                        module_id,
                        moduleScore
                    }
                });
                return;
            }

            const nextScreen = allScreens[currentIndex];
            navigate("/email-next-screen", {
                state: {
                    module_id,
                    section_id: nextScreen.section_id,
                    screen_id: nextScreen.screen_id,
                    screenCounter,
                    sectionCounter,
                    numberOfTrys,
                    scorePerQuestion,
                    moduleScore
                }
            });

        } catch (error) {
            console.error("❌ Greška pri dohvaćanju podataka:", error);
        }
    };

    return (
        <div className="results-container">
            <div className="results-card">
                <img src={logo} alt="Logo" className="results-logo" />
                <h2 className="results-title">CYBER AWARENESS TRAINING CENTRE</h2>

                <img src={successicon} alt="Success" className="results-icon" />

                <p className="results-text">OSVOJENI BROJ BODOVA</p>
                <p className="results-text">{recivedScore} XP</p>

                <button className="continue-button" onClick={nextLecture}>
                    CONTINUE
                </button>

                <div className="nav-icons">
                    <button className="icon-button" onClick={() => navigate("/home")}>
                        <i className="fas fa-home"></i>
                    </button>
                    <button className="icon-button">
                        <i className="fas fa-star"></i>
                    </button>
                    <button className="icon-button" onClick={() => navigate("/profile")}>
                        <i className="fas fa-user"></i>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ResultsScreen;